import React, { Component } from 'react';
import '../styles.css';
import { connect } from 'react-redux';
import { windowSize, delay, playSound, apple, dbget, dbset } from '../../HOME/utils';
import Cell from './Cell';
import _ from 'lodash';
import * as f from '../logic';
import { SIDES, SPIN_DURATION, HELPED_KEY, CUURENT_VERSION } from '../const';
import { updateStats, updateSteps, showHelp, setHelped } from '../REDUX/actions';
import { requestResetStats, requestSurrender } from '../../HOME/REDUX/actions';
import MessageBox from '../../HOME/COMPONENTS/MessageBox';
import { SLOW } from '../../HOME/const';
import Help from './Help';
import Loader from '../../HOME/COMPONENTS/Loader';

const FLIP_DURATION = 500;

class Board extends Component {
  state = { flip: false };
  progressRef = React.createRef();

  onResize = () => {
    this.forceUpdate();
  };

  componentDidMount() {
    window.addEventListener('resize', this.onResize);

    dbget(HELPED_KEY, response => {
      if (!response && !this.props.helped) {
        this.props.showHelp(true);
        dbset(HELPED_KEY, true);
        this.props.setHelped();
      }
    });

    this.load();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);

    this.props.requestResetStats(false);
    this.props.requestSurrender(false);
    this.props.showHelp(false);
  }

  load = () => {
    dbget(f.boardKey(this.props), json => {
      if (!json) {
        this.init();
        return;
      }

      const { version, steps, palette, shape, cells } = this.fromJson(json);

      if ((version || 0) < CUURENT_VERSION) {
        this.init();
        return;
      }

      this.palette = palette;
      this.cells = cells;
      this.setState({ shape });
      this.props.updateSteps(steps);

      this.setState({ progress: true });
      delay(() => this.progressRef.current && this.progressRef.current.click(), 2000);
    });
  };

  restart = () => {
    if (apple) {
      this.cells = null;
      this.forceUpdate();
    } else {
      this.setState({ flip: true });
    }

    delay(() => {
      this.init();
      this.setState({ flip: false }, () => delay(() => this.block(false), FLIP_DURATION));
    }, FLIP_DURATION + 300);
  };

  init = () => {
    playSound(this.props, 'dice');

    this.setState({ over: false });
    this.surrender = false;

    this.props.updateSteps(0);
    this.pickShape();
    this.createPalette();

    let colorCount = _.random(2, 5);

    if (colorCount === 2) {
      colorCount = _.random(2, 5);
    }

    let over;

    do {
      this.cells = [];

      if (this.props.mode === SIDES) {
        this.initSides(colorCount);
      } else {
        this.initCorners(colorCount);
      }

      this.updateAligned();
      over = this.gameOver();
    } while (over);
  };

  pickShape = () => {
    const shapes = ['circle', 'square', 'rhombus', 'star', 'segments', 'hearts', 'cog', 'swastika', 'celtic'];
    const shape = shapes[_.random(shapes.length - 1)];
    this.setState({ shape });
  };

  cellIndex = (row, col) => {
    return (row - 1) * this.props.size + col - 1;
  };

  initSides = colorCount => {
    const { size } = this.props;

    for (let row = 1; row <= size; row++) {
      for (let col = 1; col <= size; col++) {
        var cell = { row, col, colors: [0, 0, 0, 0], turns: _.random(3) };

        // eslint-disable-next-line no-loop-func
        _.forEach([0, 3, 1, 2], k => {
          let index = _.random(colorCount - 1);

          switch (k) {
            case 0: // top
              if (row > 1) {
                index = this.cells[this.cellIndex(row - 1, col)].colors[2];
              }
              break;
            case 3: // left
              if (col > 1) {
                index = this.cells[this.cellIndex(row, col - 1)].colors[1];
              }
              break;
            case 1: // right
              break;
            case 2: // bottom
              while (index === cell.colors[0] && index === cell.colors[3] && index === cell.colors[1]) {
                index = _.random(colorCount - 1);
              }
              break;
            default:
          }

          cell.colors[k] = index;
        });

        this.cells.push(cell);
      }
    }
  };

  initCorners = colorCount => {
    const { size } = this.props;

    const p = [...Array(size + 1)].map(_ => Array(size + 1).fill(0));

    for (let i = 0; i <= size; i++) {
      for (let j = 0; j <= size; j++) {
        let index = _.random(colorCount - 1);

        if (i > 0 && j > 0) {
          while (index === p[i - 1][j - 1] && index === p[i - 1][j] && index === p[i][j - 1]) {
            index = _.random(colorCount - 1);
          }
        }

        p[i][j] = index;
      }
    }

    for (let i = 0; i < size; i++) {
      for (let j = 0; j < size; j++) {
        var cell = { row: i + 1, col: j + 1, colors: [p[i][j], p[i][j + 1], p[i + 1][j + 1], p[i + 1][j]], turns: _.random(3) };
        this.cells.push(cell);
      }
    }
  };

  createPalette = () => {
    this.palette = _.sampleSize(['red', 'yellow', 'green', 'blue', 'purple'], 5);
  };

  updateAligned = () => {
    if (_.filter(this.cells, cell => cell.rotating).length) {
      return;
    }

    _.forEach(this.cells, cell => {
      cell.aligned = f.isAligned(this.props, this.cells, cell);
    });

    const over = this.gameOver();
    this.setState({ over });

    if (!over) {
      this.save();
      return;
    }

    // game over
    if (!this.surrender && this.props.steps > 0) {
      f.setStats(this.props);

      this.block(true);
    }

    delay(() => {
      playSound(this.props, this.surrender ? 'draw' : 'won');

      _.forEach(this.cells, (cell, i) => {
        cell.spin = true;
      });

      this.forceUpdate();

      delay(() => {
        _.forEach(this.cells, (cell, i) => {
          cell.spin = false;
        });

        this.forceUpdate();
        this.block(false);
      }, SPIN_DURATION);
    }, 300);
  };

  block = on => {
    this.blocked = on;
    this.props.toolbar.current.forceUpdate();
  };

  gameOver = () => {
    const over = _.every(this.cells, 'aligned');
    return over;
  };

  doReveal = () => {
    this.surrender = true;

    f.setStats(this.props, true);

    this.block(true);

    _.forEach(this.cells, (cell, i) => {
      cell.reveal = true;
    });

    this.forceUpdate();
  };

  handleConfirmSurrender = yes => {
    if (yes) {
      playSound(this.props, 'click');
      this.block(true);
      delay(this.doReveal, SLOW);
    }

    delay(() => this.props.requestSurrender(false));
  };

  handleConfirmResetStats = yes => {
    if (yes) {
      this.props.updateStats();
    }

    delay(() => this.props.requestResetStats(false));
  };

  save = () => {
    dbset(f.boardKey(this.props), this.toJson());
  };

  toJson = () => {
    const json = JSON.stringify(
      { version: CUURENT_VERSION, steps: this.props.steps, palette: this.palette, shape: this.state.shape, cells: this.cells },
      ['version', 'steps', 'palette', 'shape', 'cells', 'row', 'col', 'colors', 'turns', 'aligned']
    );

    return json;
  };

  fromJson = json => {
    return JSON.parse(json);
  };

  handleDismissProgress = () => {
    delay(() => this.setState({ progress: false }));
  };

  render() {
    if (!this.cells) {
      return <Loader width={125} />;
    }

    const { size, surrender, resetStats, help } = this.props;
    const { x, y } = windowSize();
    let width = Math.min(x, y - 200) * 0.9;
    width = Math.min(width, 600);
    const cellWidth = (width + size - 1) / size;
    width = `${width}px`;
    const grid = `${_.repeat('auto ', size)}/${_.repeat('auto ', size)}`;
    const transform = `rotateX(${this.state.flip ? 90 : 0}deg)`;
    const transition = `transform ${FLIP_DURATION}ms linear`;

    return (
      <div className="tt-board-container">
        <div className="tt-board" style={{ width, height: width, grid, transform, transition }}>
          {_.map(this.cells, (cell, i) => {
            return (
              <span key={i}>
                <Cell board={this} mode={this.props.mode} size={this.props.size} width={cellWidth} shape={this.state.shape} cell={cell} />
              </span>
            );
          })}
        </div>
        {surrender ? <MessageBox message="Give up?" yesNo width={width} onReply={this.handleConfirmSurrender} /> : null}
        {resetStats ? <MessageBox message="Reset stats?" yesNo width={width} onReply={this.handleConfirmResetStats} /> : null}
        {this.state.progress ? <MessageBox ref={this.progressRef} message="GAME IN PROGRESS" onReply={this.handleDismissProgress} /> : null}
        {help ? <Help /> : null}
      </div>
    );
  }
}

function mapStateToProps({ tt, common }) {
  return { ...tt, ...common };
}

export default connect(
  mapStateToProps,
  { updateStats, updateSteps, requestSurrender, requestResetStats, showHelp, setHelped },
  null,
  { forwardRef: true }
)(Board);
